import { render, staticRenderFns } from "./programPeriodEdit.vue?vue&type=template&id=f37a4892&scoped=true&"
import script from "./programPeriodEdit.vue?vue&type=script&lang=js&"
export * from "./programPeriodEdit.vue?vue&type=script&lang=js&"
import style0 from "./programPeriodEdit.vue?vue&type=style&index=0&id=f37a4892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37a4892",
  null
  
)

export default component.exports